import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import DynamicHeader from '../Header/DynamicHeader';

const NewPools = ({ tokens, showHeader = true, onShowMore , loading }) => {
  const [tokenData, setTokenData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (tokens.length > 0) {
      const formattedData = tokens.map((token) => {

        return {
          name: token.CoinName,
          price: token.price,
          age: token.age,
          txn: token.totalTransactions,
          fiveMin: token.pricePercentage.m5,
          oneHr: token.pricePercentage.h1,
          sixHr: token.pricePercentage.h6,
          twentyFourHr: token.pricePercentage.h24,
          vol: token.volume,
          liq: token.liquidity,
          mcap: token.Mcap,
          fdv: token.fdv,
          address: token.tokenAddress,
          chainName: token.chainName,
        };
      });

      setTokenData(formattedData);
      // setLoading(false);
    } else {
      setTokenData([]);
      // setLoading(false);
    }
  }, [tokens]);

  const handleRowClick = (e, address, chainName) => {
    if (chainName.toLowerCase() === 'solana') {
      return;
    }

    if (e.target.classList.contains('coin-name-cell')) {
      navigate(`/details/${address}?chainName=${chainName}`, { state: { tokenAddress: address } });
    }
  };

  const handleShowMore = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
      onShowMore(); // Call the onShowMore prop to load more data
    }
  };

  return (

    <div className="newpool-background">
      {showHeader && !loading && <Header />}
{/* <DynamicHeader/> */}
      {!loading && tokenData.length > 0 && (
  <div className="table-container-new custom-scrollbar">
    <table className="table-table-container">
      <thead className="active-header">
        <tr>
          <th>Coin Name</th>
          <th>Price</th>
          <th>Age</th>
          <th>TXN</th>
          <th>5M</th>
          <th>1H</th>
          <th>6H</th>
          <th>24H</th>
          <th>VOL</th>
          <th>LIQ</th>
          <th>MCAP</th>
          <th>FDV</th>
        </tr>
      </thead>
      <tbody className="use-cen">
  {tokenData.map((row, index) => (
    <tr
      key={index}
      onClick={(e) => handleRowClick(e, row.address, row.chainName)}
    >
      <td className="coin-name-cell">{row.name}</td>
      <td>${row.price}</td>
      <td>{row.age}</td>
      <td>{row.txn}</td>
      <td
        className={row.fiveMin < 0 ? "negative" : "positive"}
        style={{ color: row.fiveMin < 0 ? "red" : "green" }}
      >
        {row.fiveMin}
      </td>
      <td
        className={row.oneHr < 0 ? "negative" : "positive"}
        style={{ color: row.oneHr < 0 ? "red" : "green" }}
      >
        {row.oneHr}
      </td>
      <td
        className={row.sixHr < 0 ? "negative" : "positive"}
        style={{ color: row.sixHr < 0 ? "red" : "green" }}
      >
        {row.sixHr}
      </td>
      <td
        className={row.twentyFourHr < 0 ? "negative" : "positive"}
        style={{ color: row.twentyFourHr < 0 ? "red" : "green" }}
      >
        {row.twentyFourHr}
      </td>
      <td>${row.vol}</td>
      <td>${row.liq}</td>
      <td>${row.mcap}</td>
      <td>${row.fdv}</td>
    </tr>
  ))}
</tbody>

    </table>
        </div>
      )}

{tokens.length > 0 && hasMoreData && (
  <div className="show-more-container">
    <button onClick={handleShowMore} disabled={loading}>
      {loading ? "Loading..." : "Show More"}
    </button>
  </div>
)}

    </div>
  );
};

export default NewPools;